<template>
   <div id="mobile">
      <div class="top" v-if="$route.meta.title === '首页'">
        <div class="footer_title">广西信息职业技术学院招生与就业处</div>
        <div class="left">
          <!-- <img class="logo" src="@/assets/image_h5/logo.png" alt=""> -->

          <div class="detail">招生热线：0771-2205522，2205533
            <!-- <span style="margin-left: 18.5vw">15777111303</span> -->
          </div>
          <div class="detail">邮政编码：530200</div>
          <div class="detail">学校地址：广西南宁市邕宁区步云路31号</div>
          <div class="detail">实习监督咨询电话：177 5286 4567</div>
        </div>
         <div class="right">
            <div class="ewm-box">
              <img class="ewm" src="@/assets/img_app/footer1.png" alt="">
              <div class="name">招生小程序</div>
            </div>
            <div class="ewm-box">
              <img class="ewm" src="@/assets/img_app/footer2.png" alt="">
              <div class="name">官方公众号</div>
            </div>

        </div>
      </div>
      <div class="bottom">
        <div class="b-1">本网站由广西信息职业技术学院委托校派教育科技有限公司运行管理</div>
        <div class="b-1">Copyright © 广西信息职业技术学院 桂ICP备2021007370号 </div>
        <div class="b-1">---------- Admissions Office ----------</div>
      </div>
    </div>
</template>

<script>
export default {
  name: '',
  components: {},
  props: {},
  data () {
    return {}
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {},
  methods: {}
}
</script>

<style lang="scss" scoped>
   #mobile{
      bottom: 0;
      color: #fff;
      font-size: 3.7333vw;
  .top{
      background: #4E55AF;
      padding: 5.3333vw 6.6667vw;
      .footer_title {
        margin-bottom: 3.2vw;
        font-size: 5.3333vw;
      }
    .left{
      .logo{
        display: block;
        width: 68vw;
        height: 13.3333vw;
        margin: 0 auto 4.6667vw;
      }
      .detail{
        font-weight: 400;
        margin-bottom: 3.4667vw;
      }

    }
    .right{
      display: flex;
      width: 42%;
      padding-top: 1.7333vw;
      .ewm-box{
        margin-left: 14.3333vw;
        display: flex;
        flex-direction: column;
        .ewm{
          width: 21.3333vw;
          height: 21.3333vw;
          margin-bottom: 3.2vw;
        }
        .name{
          font-weight: 500;
          line-height: 2.9333vw;
          text-align: center;
        }
      }
    }
  }
  .bottom{
    padding: 2.1333vw;
    // height: 18.6667vw;
    text-align: center;
    font-weight: 400;
    background: #31378E;
    div:first-child {
      margin-bottom: 1.0667vw;
    }
  }
}

</style>
